import { render, staticRenderFns } from "./CommunityUsersList.vue?vue&type=template&id=24e4ffa6&"
import script from "./CommunityUsersList.vue?vue&type=script&lang=js&"
export * from "./CommunityUsersList.vue?vue&type=script&lang=js&"
import style0 from "./CommunityUsersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports